import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Inventario } from './inventario.model';
import { DefaultService } from 'src/app/core/framework/default-service';


@Injectable()
export class InventarioService extends DefaultService<Inventario> {
  static URL = '/api/estoque/v1/inventarios';

  constructor(
      public httpClient: HttpClient,
      public errorHandler: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandler,
      InventarioService.URL
    );
  }

}
